//         appVersion: '<appVersion>',
//         featureFlagServiceClientKey: '<featureFlagServiceClientKey>',
//         fuelEnvironmentName: '<fuelEnvironmentName>',
//         subDomainName: '<subDomainName>',
//         fuelDomainName: '<fuelDomainName>',
//         fuelPortalUrl: '<fuelPortalUrl>',
//         authUrl: '<authUrl>',
//         authClientID: '<authClientID>',

interface Config {
  appVersion: string;
  featureFlagServiceClientKey: string;
  fuelEnvironmentName: string;
  subDomainName: string;
  fuelDomainName: string;
  fuelPortalUrl: string;
  fuelPortalFastUrl: string;
  fuelToolsUrl: string;
  fuelToolsFastUrl: string;
  authUrl: string;
  authClientID: string;
}

const config: Config = window.fuelUIGlobals;

// console.log('config', config);

export { config };

// Add this declaration to inform TypeScript about window.fuelUIGlobals
declare global {
  interface Window {
    fuelUIGlobals: Config;
  }
}
